import { render, staticRenderFns } from "./PhagwaGame.vue?vue&type=template&id=41bd023f&"
import script from "./PhagwaGame.vue?vue&type=script&lang=js&"
export * from "./PhagwaGame.vue?vue&type=script&lang=js&"
import style0 from "./PhagwaGame.vue?vue&type=style&index=0&id=41bd023f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports